import { get, upperCase, split, includes } from 'lodash';
import moment from 'moment';
import { useState, useEffect } from 'react';
import useInterval from '../hooks/useInterval';
import { calculateBillingDeadline } from '../../utils/misc';

// TODO: migrar a utilssss
const DESPACHO_EXPRESS = 'DESPACHO_EXPRESS';

const OrderShippingEstimate = ({ children, createdAt, pickingInfo, id, withInterval, ...data }) => {
    const [now, updateNow] = useState(moment());
    const isInvoiced = includes([5, 6, 34, 41, 50, 51, 53, 54, 55, 56, 57, 58, 59, 60], parseInt(get(pickingInfo, 'status.code', 0)));
    const date = split(get(pickingInfo, 'posDetail[0].date'), ' ');
    const hour = get(pickingInfo, 'posDetail[0].hour');
    const invoiceDate = `${date[0]} ${hour}`;
    const logisticsInfo = get(data, 'order.logisticsInfo', get(data, 'logisticsInfo', { selectedSla: '', deliveryWindow: {} }));
    const selectedSlaCode = upperCase(get(logisticsInfo, 'selectedSla', 'despacho express')).replace(/\s/g, '_');
    const windowStart = get(logisticsInfo, 'shippingETA');
    const windowEnd = get(logisticsInfo, 'shippingETAend');
    const shippingETA = moment(windowStart || get(logisticsInfo, 'shippingEstimateDate'), 'YYYY-MM-DD HH:mm:ss');
    const shippingETAend = moment(windowEnd);
    const shippingEstimateDate = moment(get(logisticsInfo, 'shippingEstimateDate'), 'YYYY-MM-DD HH:mm:ss');
    const isPickup = includes(['CLICK_AL_AUTO', 'RETIRO_EN_TIENDA'], selectedSlaCode);
    const dateNow = moment().format('YYYY-MM-DD HH:mm:ss');
    const isExpress = selectedSlaCode === DESPACHO_EXPRESS;

    const invoicedInTime = (field) => {
        return isInvoiced && field.diff(moment(invoiceDate, 'YYYY-MM-DD HH:mm')) >= 0;
    };

    useEffect(() => {
        const interval = withInterval ? setInterval(() => updateNow(moment()), 1000) : 0;

        return () => {
            withInterval && clearInterval(interval);
        };
    }, []);

    const shippingCountdownColor = ({ hours, minutes }) => {
        const rgba = 'rgba(219, 89, 89, 0.1)';

        if (hours <= 0) {
            if (minutes < 30) {
              return { rgba, hex: '#fc6262', text: '#ffffff' };
            } else if (minutes < 45) {
              return { rgba, hex: '#f2cf5a', text: '#000000' };
            }
        }

        return { rgba, hex: '#f0f0f0', text: '#000000' };
    };

    const shippingCountdown = (deliveryTime) => {
        const getDate = () => {
            if (isExpress) return moment(createdAt, 'YYYY-MM-DD HH:mm').add(deliveryTime, 'minutes');
            return calculateBillingDeadline(get(data, 'category'), get(data, 'time'), shippingETA, shippingETAend);
        };

        const formatTime = (time) => time < 10 ? `0${time}` : time;
        const duration = moment.duration(getDate().diff(dateNow));

        if (duration.seconds() < 0) {
            clearInterval(useInterval);
            return {
                label: 'Fuera de plazo',
                outOfTime: true,
                colors: shippingCountdownColor({ hours: 0, minutes: 0 })
            };
        }

        const temp = {
            hours: formatTime(duration.days() >= 1 ? duration.hours() + (24 * duration.days()) : duration.hours()),
            minutes: formatTime(duration.minutes()),
            seconds: formatTime(duration.seconds())
        };

        return {
            label: `${temp.hours}:${temp.minutes}`,
            outOfTime: false,
            colors: shippingCountdownColor({ hours: temp.hours, minutes: temp.minutes })
        };
    };

    if (isExpress) {
        const st = parseInt(get(logisticsInfo, 'shippingEstimate', '0'));
        const deliveryTime = st === 0 ? 90 : st;
        const hours = Math.floor(deliveryTime / 60) < 10 ? `0${Math.floor(deliveryTime / 60)}` : Math.floor(deliveryTime / 60);
        const minutes = (deliveryTime % 60) < 10 ? `0${(deliveryTime % 60)}` : (deliveryTime % 60);
        const deliveryPromiseDate = `${hours}:${minutes}`;
        const diff = moment().diff(deliveryTime, 'minutes');
        const isDelayed = diff >= 0;

        const shippingColor = () => {
            if (diff >= -20) return { rgba: 'rgba(219, 89, 89, 0.1)', hex: '#DB5959' };
            if ((diff >= -30) && (diff < -20)) return { rgba: 'rgba(243, 133, 48, 0.1)', hex: '#F38630' };
            if ((diff >= -45) && (diff < -30)) return { rgba: 'rgba(248, 203, 0, 0.1)', hex: '#F8CA00' };
            return { rgba: '#FFFFFF', hex: '#FFFFFF' };
        };

        return children({
            isDelayed,
            deliveryTimeDate: `${moment(shippingETA).format('DD/MM/YYYY')} ${moment(createdAt, 'YYYY-MM-DD HH:mm').add(deliveryTime, 'minutes').format('HH:mm')}`,
            deliveryDate: moment(shippingETA).format('DD/MM/YYYY'),
            deliveryTimeHour: moment(createdAt, 'YYYY-MM-DD HH:mm').add(deliveryTime, 'minutes').format('HH:mm'),
            deliveryTimeHourBySla: `${moment(createdAt, 'YYYY-MM-DD HH:mm').add(deliveryTime, 'minutes').format('HH:mm')} hrs.`,
            deliveryTime: `${deliveryTime} min`,
            diffInMinutes: diff,
            shippingColor: shippingColor({ }),
            value: `${deliveryPromiseDate}`,
            text: `${deliveryPromiseDate} horas`,
            shippingCountdown: shippingCountdown(deliveryTime),
            selectedSlaCode,
            invoicedInTime: invoicedInTime(moment(shippingEstimateDate, 'YYYY-MM-DD HH:mm:ss'))
        });
    }

    const diff = moment().diff(shippingETA, 'hours');
    const isDelayed = diff >= 0;
    const deliveryTime = `${moment(shippingETA).format('HH:mm')} - ${moment(shippingETAend).format('HH:mm')}`;
    const deliveryAverage = isPickup ? shippingETA : moment(get(logisticsInfo, 'deliveryAverage'), 'YYYY-MM-DD HH:mm:ss');

    return children({
        deliveryTimeDate: moment(shippingETA).format('DD/MM/YYYY'),
        deliveryDate: moment(shippingETA).format('DD/MM/YYYY'),
        value: `${shippingETAend.format('HH:mm')}`,
        text: `${shippingETAend.format('HH:mm')} horas`,
        deliveryTime,
        deliveryTimeHour: deliveryTime,
        deliveryTimeHourBySla: `${moment(shippingETA).format('HH:mm')} hrs.`,
        isDelayed,
        shippingCountdown: shippingCountdown(),
        selectedSlaCode,
        invoicedInTime: invoicedInTime(deliveryAverage)
    });
};

export default OrderShippingEstimate;
